import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForBig, wrapIdForCommon, wrapIdForFold, wrapIdForInput, wrapIdForText } from '@framework/workbench/util/wrap-id-util';
import { FOLD_ICON_TYPE } from '@framework/workbench/ui/fold/config';
import { ShrinkType } from '@tencent/workbench';
import {
    AlignType,
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

// 双栏插入tab公用配置
export const COMMON_TAB_START_DOUBLE_DATA = [
    [
        [
            [ActionType.UNDO, ActionType.REDO],
            [ActionType.FORMAT_BRUSH, ActionType.CLEAR_FORMAT],
        ],
    ],
    [
        {
            shelter: wrapIdForFold(ActionType.INSERT_ALL),
            buttons: [
                [
                    wrapIdForBig(ActionType.INSERT_ALL),
                    wrapIdForBig(ActionType.INSERT_TEXT),
                    wrapIdForBig(ActionType.INSERT_SHAPE),
                    wrapIdForBig(ActionType.INSERT_LAYOUT),
                    wrapIdForBig(ActionType.INSERT_PLACEHOLDER),
                ],
            ],
        },
    ],
    [
        {
            shelter: wrapIdForBig(FOLD_ICON_TYPE.FONT_SETTING),
            buttons: [
                [
                    wrapIdForInput(ActionType.FONT),
                    wrapIdForInput(ActionType.FONTSIZE),
                    ActionType.FONTSIZE_UP,
                    ActionType.FONTSIZE_DOWN,
                ],
                [
                    ActionType.BOLD,
                    ActionType.ITALIC,
                    ActionType.UNDERLINE,
                    ActionType.DELETELINE,
                    ActionType.SUPERSCRIPT,
                    ActionType.SUBSCRIPT,
                    ActionType.BACKCOLOR,
                    ActionType.FORECOLOR,
                ],
            ],
        },
    ],
    [
        {
            shelter: wrapIdForBig(FOLD_ICON_TYPE.PARAGRAPH),
            buttons: [
                [
                    ActionType.ITEMNUMBER,
                    ActionType.DIGITNUMBER,
                    IndentType.INDENT_REDUCE,
                    IndentType.INDENT_INCREASE,
                    ActionType.ROW_SPACE,
                    ActionType.COLUMNS,
                ],
                [
                    AlignType.HORIZONTAL_LEFT,
                    AlignType.HORIZONTAL_CENTER,
                    AlignType.HORIZONTAL_RIGHT,
                    AlignType.HORIZONTAL_JUSTIFY,
                    AlignType.HORIZONTAL_DISTRIBUTE,
                    ActionType.VERTICAL_ALIGN,
                ],
            ],
        },
    ],
    {
        shelter: wrapIdForBig(FOLD_ICON_TYPE.PAINTING),
        items: [
            [[wrapIdForBig(ActionType.MOVE_ITEM)]],
            [
                [wrapIdForText(ActionType.EFFECT), wrapIdForText(ActionType.FILLCOLOR)],
                [wrapIdForCommon(ActionType.GROUP), wrapIdForText(ActionType.BORDERCOLOR)],
            ],
        ],
    },
    [
        {
            shelter: wrapIdForBig(`${ActionType.INSERT_PICTURE}-parent`),
            buttons: [
                [
                    wrapIdForBig(ActionType.TAILOR_PIC),
                    wrapIdForBig(ActionType.MULTI_TAILOR_PIC),
                    wrapIdForBig(ActionType.TRANSPARENCY),
                ],
            ],
        },
    ],
    [
        {
            shelter: wrapIdForBig(`${ActionType.INSERT_FORM}-parent`),
            buttons: [[wrapIdForBig(ActionType.BORDERSTYLE), wrapIdForBig(ActionType.MERGE_CELL)]],
        },
    ],
    [wrapIdForBig(ActionType.INSERT_ANIMATION)],
];

// 双栏插入tab公用配置
export const COMMON_TAB_INSERT_DOUBLE_DATA = [
    [
        wrapIdForBig(ActionType.INSERT_BLANK_SLIDE),
        wrapIdForBig(ActionType.INSERT_TEMPLATE_SLIDE),
        wrapIdForBig(ActionType.AI_GENERATE_PAGE),
    ],

];

export const COMMON_INSERT_DOUBLE_GROUP = [
    wrapIdForBig(ActionType.INSERT_TEXT),
    wrapIdForBig(ActionType.INSERT_SHAPE),
    wrapIdForBig(ActionType.INSERT_LAYOUT),
    wrapIdForBig(ActionType.INSERT_PLACEHOLDER),
    wrapIdForBig(ActionType.INSERT_PICTURE),
    wrapIdForBig(ActionType.INSERT_AUDIO),
    wrapIdForBig(ActionType.INSERT_VIDEO),
    `${ActionType.INSERT_FORM}-parent-custom`,
    wrapIdForBig(ActionType.INSERT_WITH_LINK),
    wrapIdForBig(ActionType.INSERT_CHART),
    wrapIdForBig(ActionType.INSERT_SLIDE_FOOTER),
];

// 双栏动画tab公用配置
export const COMMON_TAB_ANIM_DOUBLE_DATA = [
    [ActionType.ANIM_PREVIEW],
    [ActionType.ANIM_ENTR, ActionType.ANIM_EMPH, ActionType.ANIM_EXIT],
    {
        items: [
            [[ActionType.ANIM_PANE]],
            [[ActionType.BATCH_HANDLE_ANIMATION]],
            [[ActionType.ANIM_BRUSH]],
            {
                shrinkType: ShrinkType.GROUP_TAIL,
                priority: 1,
                buttons: [[ActionType.ANIM_START], [ActionType.ANIM_DURATION]],
            },
            {
                shrinkType: ShrinkType.GROUP_TAIL,
                priority: 0,
                buttons: [[ActionType.ANIM_DELAY], [ActionType.ANIM_TRIGGER]],
            },
        ],
    },
    [ActionType.ANIM_CORNER_MARK],
];

// 双栏视图tab公用配置
export const COMMON_TAB_VIEW_DOUBLE_DATA = [
    [ActionType.EDIT_VIEW, ActionType.MASTER_VIEW],
    {
        items: [
            [
                [ActionType.DISPLAY_TEXT_RULER, ActionType.DISPLAY_GUIDES],
                [ActionType.DISPLAY_GRID_LINE, ActionType.TOGGLE_SNAP_LINE],
            ],
            [[ActionType.NOTE_SWITCH]],
        ],
    },
    [ActionType.ADJUST_SLIDE, ActionType.AUTO_ADJUST_SLIDE],
];

// 双栏美化tab公用配置
export const COMMON_TAB_BEAUTIFY_DOUBLE_DATA = [
    [
        ActionType.CHANGE_TEMPLATE_CONTENT,
        ActionType.CHANGE_TEMPLATE_MORE,
    ],
    [
        ActionType.CHANGE_THEME_COLOR_TOOLBAR,
        ActionType.CHANGE_THEME_COLOR_TOOLBAR_MORE,
        ActionType.CHANGE_THEME_COLOR_TOOLBAR_CUSTOM,
    ],
];

export const COMMON_BEAUTIFY_END_GROUP = [
    ActionType.SLIDE_SIZE_TOOLBAR,
    ActionType.CHANGE_BG_TOOLBAR,
    ActionType.MASTER_LAYOUT_TOOLBAR,
];

// 双栏演示tab公用配置
export const COMMON_TAB_PLAY_DOUBLE_DATA = [[ActionType.LOCAL_PLAY_FROM_BEGIN, ActionType.LOCAL_PLAY_FROM_CURRENT]];

// 单栏公用配置
export const COMMON_SIMPLE_DATA = [
    [ActionType.SINGLE_TOOLBAR_MENU],
    [ActionType.UNDO, ActionType.REDO, ActionType.FORMAT_BRUSH, ActionType.CLEAR_FORMAT],
    [
        ActionType.INSERT_ALL,
        ActionType.INSERT_TEXT,
        ActionType.INSERT_SHAPE,
        ActionType.INSERT_LAYOUT,
        ActionType.INSERT_PLACEHOLDER,
    ],

    [
        ActionType.FONT,
        ActionType.FONTSIZE,
        ActionType.FONTSIZE_UP,
        ActionType.FONTSIZE_DOWN,
        ActionType.BOLD,
        {
            shrinkType: ShrinkType.GROUP_TAIL,
            buttons: [[ActionType.ITALIC]],
            priority: 4,
        },

        {
            shrinkType: ShrinkType.GROUP_TAIL,
            buttons: [[ActionType.UNDERLINE]],
            priority: 3,
        },
        {
            shrinkType: ShrinkType.GROUP_TAIL,
            buttons: [[ActionType.DELETELINE]],
            priority: 2,
        },
        ActionType.SUPERSCRIPT,
        ActionType.SUBSCRIPT,
        {
            shrinkType: ShrinkType.GROUP_TAIL,
            buttons: [[ActionType.BACKCOLOR]],
            priority: 1,
        },
        ActionType.FORECOLOR,
    ],
    [
        ActionType.ITEMNUMBER,
        ActionType.DIGITNUMBER,
        ActionType.HORIZONTAL_ALIGN,
        ActionType.INDENT,
        ActionType.ROW_SPACE,
        ActionType.VERTICAL_ALIGN,
        ActionType.COLUMNS,
    ],
    [ActionType.MOVE_ITEM, ActionType.GROUP, ActionType.EFFECT, ActionType.FILLCOLOR, ActionType.BORDERCOLOR],
    [ActionType.BORDERSTYLE, ActionType.MERGE_CELL],
    [ActionType.TAILOR_PIC, ActionType.MULTI_TAILOR_PIC, ActionType.TRANSPARENCY],
    [ActionType.TRANSITION_CHANGE_SIMPLE, ActionType.INSERT_ANIMATION],
];
